import { render, staticRenderFns } from "./HistoricoUsuarioModal.vue?vue&type=template&id=69785ca9"
import script from "./HistoricoUsuarioModal.vue?vue&type=script&lang=js"
export * from "./HistoricoUsuarioModal.vue?vue&type=script&lang=js"
import style0 from "./HistoricoUsuarioModal.vue?vue&type=style&index=0&id=69785ca9&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports